import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const RegistrationButton = ({ event }) => {
  return (
    <section className="registration-cta py-5 bg-dark text-center">
      <Container>
        <h2 className="text-white mb-4">Ready to join us for {event.title}?</h2>
        <Button 
          as={Link} 
          to={`/register/${event.id}`} 
          size="lg" 
          className="register-btn fw-bold px-5 py-3 animate-pulse"
          style={{
            backgroundColor: '#ffc107',
            borderColor: '#ffc107',
            color: '#212529',
            fontSize: '1.25rem',
            transition: 'all 0.3s ease',
            minHeight: '60px', // Larger touch target for mobile
            width: '100%',     // Full width on mobile
            maxWidth: '300px'  // Max width for larger screens
          }}
        >
          REGISTER NOW
        </Button>
        
        <div className="mt-3">
          <small className="text-light">Limited spots available. Register early!</small>
        </div>
      </Container>
    </section>
  );
};

export default RegistrationButton;